import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    meta: {
      title: '重庆市建筑工程设计院有限责任公司'
    },
    component: Home
  },
  {
    path: '/about',
    meta: {
      title: '关于我们'
    },
    component: () => import('../views/About.vue')
  },
  {
    path: '/contact',
    meta: {
      title: '联系我们'
    },
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/news',
    meta: {
      title: '咨询动态'
    },
    component: () => import('../views/News.vue')
  },
  {
    path: '/newsdetail',
    meta: {
      title: '咨询动态详情'
    },
    component: () => import('../views/NewsDetail.vue')
  },
  {
    path: '/projects',
    meta: {
      title: '经典案例'
    },
    component: () => import('../views/Projects.vue')
  },
  {
    path: '/projectsdetail',
    meta: {
      title: '经典案例详情'
    },
    component: () => import('../views/ProjectsDetail.vue')
  },
  {
    path: '/teamcore',
    meta: {
      title: '核心团队'
    },
    component: () => import('../views/TeamCore.vue')
  },
  {
    path: '/teammember',
    meta: {
      title: '成员详情'
    },
    component: () => import('../views/TeamMember.vue')
  },
  {
    path: '/designbranch',
    meta: {
      title: '设计部门'
    },
    component: () => import('../views/DesignBranch.vue')
  },
  {
    path: '/designmember',
    meta: {
      title: '成员详情'
    },
    component: () => import('../views/DesignMember.vue')
  },
  {
    path: '/strategy',
    meta: {
      title: '项目管理'
    },
    component: () => import('../views/Strategy.vue')
  },
  {
    path: '/positionlist',
    meta: {
      title: '招聘求职'
    },
    component: () => import('../views/PositionList.vue')
  },
  {
    path: '/positiondetail',
    meta: {
      title: '招聘求职详情'
    },
    component: () => import('../views/PositionDetail.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
